'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _ChevronRight = require('@deliveroo/icon-set/react/ChevronRight');

var _ChevronRight2 = _interopRequireDefault(_ChevronRight);

var _Cross = require('@deliveroo/icon-set/react/Cross');

var _Cross2 = _interopRequireDefault(_Cross);

var _Exit = require('@deliveroo/icon-set/react/Exit');

var _Exit2 = _interopRequireDefault(_Exit);

var _House = require('@deliveroo/icon-set/react/House');

var _House2 = _interopRequireDefault(_House);

var _MenuHamburger = require('@deliveroo/icon-set/react/MenuHamburger');

var _MenuHamburger2 = _interopRequireDefault(_MenuHamburger);

var _Button = require('../Button');

var _Button2 = _interopRequireDefault(_Button);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _IconWithText = require('../IconWithText');

var _IconWithText2 = _interopRequireDefault(_IconWithText);

var _PageContainer = require('../PageContainer');

var _PageContainer2 = _interopRequireDefault(_PageContainer);

var _Span = require('../Span');

var _Span2 = _interopRequireDefault(_Span);

var _Select = require('../Select');

var _Select2 = _interopRequireDefault(_Select);

var _Spacer = require('../Spacer');

var _Spacer2 = _interopRequireDefault(_Spacer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  'wrapper': 'ccl-34852c5151a1675c',
  'solidBar': 'ccl-040cc2c76096bdd4',
  'logo': 'ccl-1b0ffd1d711941bf',
  'chinese': 'ccl-6040beb1fd1559f4',
  'deloveroo': 'ccl-05190385dc54ddf0',
  'white': 'ccl-c3b2310063912620',
  'navHeader': 'ccl-821d83c2df95c75e',
  'links': 'ccl-38913e315b3ffae4',
  'button': 'ccl-985cb265c6f6a9c1',
  'overlay': 'ccl-bcdb13588ad4dd49',
  'afterOpen': 'ccl-a2f90e83829818e5',
  'beforeClose': 'ccl-1ce5ecbcf5254482',
  'sidebar': 'ccl-bae866a32ab5c8df',
  'sidebarContent': 'ccl-d383826b68e68f89',
  'body': 'ccl-7a4968ab8c9a066b',
  'header': 'ccl-4bf1f00d5565afdf',
  'close': 'ccl-278471505a00ead6',
  'sidebarLinks': 'ccl-4876ecf18c298c50',
  'listItem': 'ccl-f1fdcd30497a827f',
  'link': 'ccl-b757c6f9e5f59909',
  'label': 'ccl-60c905a08065f0de',
  'destructive': 'ccl-5f6888b69ec07a35',
  'icon': 'ccl-0b7e49ee429aa5f2',
  'chevron': 'ccl-7871ce9cabec2a82',
  'searchWrapper': 'ccl-039ee28e826becac'
};

/**
 * The main navigation header on user-facing sites. See also: NavHeader,
 * for the main header used specifically on the consumer site.
 */

var NavHeader = function (_React$Component) {
  _inherits(NavHeader, _React$Component);

  function NavHeader(props) {
    _classCallCheck(this, NavHeader);

    var _this = _possibleConstructorReturn(this, (NavHeader.__proto__ || Object.getPrototypeOf(NavHeader)).call(this, props));

    _this.openSidebar = _this.openSidebar.bind(_this);
    _this.closeSidebar = _this.closeSidebar.bind(_this);
    _this.updateHeaderLinks = _this.updateHeaderLinks.bind(_this);
    _this.onLocaleChange = _this.onLocaleChange.bind(_this);
    _this.setHeaderLinks = _this.setHeaderLinks.bind(_this);
    _this.renderSidebarLink = _this.renderSidebarLink.bind(_this);

    _this.state = {
      isSidebarVisible: false,
      headerLinks: _this.getHeaderLinks(),
      sidebarLinks: []
    };
    return _this;
  }

  _createClass(NavHeader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var appElement = this.props.appElement;

      // we mock ReactModal in tests so this method isn't around, only do it if it is.

      if (_reactModal2.default.setAppElement) {
        _reactModal2.default.setAppElement(appElement);
      }
      this.updateHeaderLinks();
      window.addEventListener('resize', this.updateHeaderLinks);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateHeaderLinks);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var isLoggedIn = this.props.isLoggedIn;

      if (prevProps.isLoggedIn !== isLoggedIn) {
        this.setHeaderLinks();
      }
    }
  }, {
    key: 'openSidebar',
    value: function openSidebar() {
      this.setState({ isSidebarVisible: true });
    }
  }, {
    key: 'closeSidebar',
    value: function closeSidebar() {
      this.setState({ isSidebarVisible: false });
    }
  }, {
    key: 'setHeaderLinks',
    value: function setHeaderLinks() {
      this.setState({
        headerLinks: this.getHeaderLinks()
      });
    }
  }, {
    key: 'onLocaleChange',
    value: function onLocaleChange(newLocaleHref) {
      window.location = newLocaleHref;
    }
  }, {
    key: 'getLinks',
    value: function getLinks(_ref) {
      var isProtected = _ref.isProtected;
      var links = this.props.links;

      return links.filter(function (link) {
        return !!link.isProtected === isProtected;
      });
    }
  }, {
    key: 'getHeaderLinks',
    value: function getHeaderLinks() {
      var _props = this.props,
          menuLabel = _props.menuLabel,
          login = _props.login,
          isLoggedIn = _props.isLoggedIn;

      return [{
        label: menuLabel,
        onClick: this.openSidebar,
        icon: _MenuHamburger2.default
      }].concat(_toConsumableArray(!isLoggedIn ? [_extends({}, login, { icon: _House2.default })] : []), _toConsumableArray(this.getLinks({ isProtected: false })));
    }

    /**
     * This returns the list of links to render inside the expanded sidebar navigation.
     */

  }, {
    key: 'getSidebarLinks',
    value: function getSidebarLinks(links) {
      var _props2 = this.props,
          isLoggedIn = _props2.isLoggedIn,
          logout = _props2.logout,
          renderPromotions = _props2.renderPromotions;


      var sidebarLinks = [].concat(_toConsumableArray(isLoggedIn ? this.getLinks({ isProtected: true }) : []), _toConsumableArray(links), _toConsumableArray(isLoggedIn ? [_extends({}, logout, { icon: _Exit2.default, type: 'destructive' })] : []));

      return sidebarLinks.filter(function (link) {
        return !renderPromotions.find(function (promotion) {
          return promotion.link.label === link.label;
        });
      });
    }

    /**
     * Determine which of the links in the nav bar are visible, and cull any that
     * aren’t, pushing those into the sidebar.
     */

  }, {
    key: 'updateHeaderLinks',
    value: function updateHeaderLinks() {
      var login = this.props.login;

      var links = [].concat(_toConsumableArray(this.linkBar.children));
      var firstOffset = links[0].offsetTop;
      // find the indexes of links who don’t touch the top
      var linksToRemove = links.map(function (link, i) {
        return link.offsetTop === firstOffset ? null : i;
      });

      // remove the null values and to take the first hidden link index
      var firstHiddenIndex = linksToRemove.filter(function (link) {
        return link !== null;
      })[0];

      if (firstHiddenIndex !== undefined) {
        var headerLinks = this.getHeaderLinks();
        // Avoid duplicate login actions in the sidebar by removing the exposed login link
        var sidebarLinks = headerLinks.slice(firstHiddenIndex).filter(function (link) {
          return link.label !== login.label;
        });

        this.setState({
          headerLinks: headerLinks.slice(0, firstHiddenIndex),
          sidebarLinks: sidebarLinks
        });
      }
    }
  }, {
    key: 'onClickSidebarLink',
    value: function onClickSidebarLink(onClick) {
      var _this2 = this;

      return function (event) {
        if (onClick) {
          _this2.closeSidebar();
          onClick(event);
        }
      };
    }

    /**
     * This renders any single button within the always-visible nav header.
     */

  }, {
    key: 'renderHeaderLink',
    value: function renderHeaderLink(_ref2, index) {
      var icon = _ref2.icon,
          label = _ref2.label,
          onClick = _ref2.onClick,
          href = _ref2.href;

      var LinkTag = 'a';

      if (onClick) {
        LinkTag = 'button';
      }

      return _react2.default.createElement(
        'li',
        { key: 'header-link-' + label + '-' + index },
        _react2.default.createElement(
          LinkTag,
          {
            className: styles.button,
            href: href,
            onClick: onClick,
            type: onClick ? 'button' : undefined
          },
          _react2.default.createElement(
            _IconWithText2.default,
            { component: icon, size: 'small', color: 'teal' },
            _react2.default.createElement(
              _Span2.default,
              { color: 'black', spacing: '0 0 0 x-small' },
              label
            )
          )
        )
      );
    }

    /**
     * This renders the always-visible nav bar, containing however many links can
     * fit depending on the viewport size.
     */

  }, {
    key: 'renderHeader',
    value: function renderHeader() {
      var _this3 = this;

      var _props3 = this.props,
          isSolidBar = _props3.isSolidBar,
          containerMaxWidth = _props3.containerMaxWidth,
          home = _props3.home,
          logoVariant = _props3.logoVariant,
          logoColor = _props3.logoColor,
          searchComponent = _props3.searchComponent;


      var LinkTag = 'a';

      if (home.onClick) {
        LinkTag = 'button';
      }

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames4.default)(styles.wrapper, _defineProperty({}, styles.solidBar, isSolidBar)) },
        _react2.default.createElement(
          _PageContainer2.default,
          { maxWidth: containerMaxWidth },
          _react2.default.createElement(
            'div',
            { className: styles.navHeader },
            _react2.default.createElement(
              LinkTag,
              {
                className: (0, _classnames4.default)(styles.logo, styles[logoVariant], styles[logoColor]),
                href: home.href,
                onClick: home.onClick,
                type: home.onClick ? 'button' : undefined
              },
              'Deliveroo'
            ),
            searchComponent && _react2.default.createElement(
              'div',
              { className: styles.searchWrapper },
              searchComponent
            ),
            _react2.default.createElement(
              'ul',
              {
                className: styles.links,
                ref: function ref(el) {
                  _this3.linkBar = el;
                }
              },
              this.state.headerLinks.map(function (link, index) {
                return _this3.renderHeaderLink(link, index);
              })
            )
          )
        )
      );
    }

    /**
     * This renders a links displayed in the expanded navigation, either
     * fullscreen (on mobile) or as a flyout menu (on tablet and above).
     * Link subtext is only visible in the sidebar.
     */

  }, {
    key: 'renderSidebarLink',
    value: function renderSidebarLink(_ref3) {
      var onClick = _ref3.onClick,
          label = _ref3.label,
          subtext = _ref3.subtext,
          href = _ref3.href,
          type = _ref3.type,
          icon = _ref3.icon;

      var LinkTag = 'a';
      if (onClick) {
        LinkTag = 'button';
      }

      return _react2.default.createElement(
        'li',
        { key: label, className: styles.listItem },
        _react2.default.createElement(
          LinkTag,
          {
            href: href,
            onClick: this.onClickSidebarLink(onClick),
            className: (0, _classnames4.default)(styles.link, _defineProperty({}, styles.destructive, type === 'destructive')),
            type: onClick ? 'button' : undefined
          },
          _react2.default.createElement(
            'span',
            { className: styles.icon },
            _react2.default.createElement(_Icon2.default, {
              component: icon,
              size: 24,
              color: type === 'destructive' ? 'red' : 'light-grey',
              spacing: [null, 'medium', null, null]
            })
          ),
          _react2.default.createElement(
            'span',
            { className: styles.label },
            _react2.default.createElement(
              _Span2.default,
              { isBlock: true, size: 'regular' },
              label
            ),
            subtext && _react2.default.createElement(
              _Span2.default,
              { size: 'small', color: 'grey', adjacentVerticalSpacing: 'small', isBlock: true },
              subtext
            )
          ),
          _react2.default.createElement(
            'span',
            { className: styles.chevron },
            _react2.default.createElement(_Icon2.default, { component: _ChevronRight2.default, size: 18, color: 'teal' })
          )
        )
      );
    }
  }, {
    key: 'renderPicker',
    value: function renderPicker(type, values, onChange) {
      var _this4 = this;

      if (values.length === 0) return null;

      var selected = values.filter(function (option) {
        return option.selected;
      })[0] || values[0];

      var handleOnChange = function handleOnChange(value) {
        if (onChange) onChange(value);
        _this4.onLocaleChange(value);
      };

      return _react2.default.createElement(
        _Select2.default,
        {
          id: type + '-picker',
          name: type,
          key: type,
          selectedOptionText: selected.label,
          value: selected.href,
          onChange: handleOnChange,
          spacing: { mobile: 'medium 0 0 0', tablet: 'large 0 0 0' }
        },
        values.map(function (opt) {
          return _react2.default.createElement(
            'option',
            { key: opt.label, value: opt.href },
            opt.label
          );
        })
      );
    }
  }, {
    key: 'renderSidebar',
    value: function renderSidebar() {
      var _props4 = this.props,
          logoVariant = _props4.logoVariant,
          isLoggedIn = _props4.isLoggedIn,
          login = _props4.login,
          languages = _props4.languages,
          onLanguageChange = _props4.onLanguageChange,
          countries = _props4.countries,
          onCountryChange = _props4.onCountryChange,
          renderPromotions = _props4.renderPromotions,
          closeButtonLabel = _props4.closeButtonLabel;
      var sidebarLinks = this.state.sidebarLinks;


      return _react2.default.createElement(
        _reactModal2.default,
        {
          onRequestClose: this.closeSidebar,
          isOpen: this.state.isSidebarVisible,
          className: {
            base: styles.sidebar,
            afterOpen: styles.afterOpen,
            beforeClose: styles.beforeClose
          },
          overlayClassName: {
            base: styles.overlay,
            afterOpen: styles.afterOpen,
            beforeClose: styles.beforeClose
          },
          closeTimeoutMS: 200
        },
        _react2.default.createElement(
          'nav',
          { className: styles.sidebarContent },
          _react2.default.createElement(
            'div',
            { className: styles.header },
            _react2.default.createElement(
              'span',
              { className: (0, _classnames4.default)(styles.logo, styles[logoVariant]) },
              'Deliveroo'
            ),
            _react2.default.createElement(
              'button',
              {
                className: styles.close,
                onClick: this.closeSidebar,
                type: 'button',
                'aria-label': closeButtonLabel
              },
              _react2.default.createElement(_Icon2.default, { component: _Cross2.default })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.body },
            !isLoggedIn && _react2.default.createElement(
              _Button2.default,
              {
                isBlock: true,
                href: login.href,
                onClick: this.onClickSidebarLink(login.onClick),
                spacing: 'medium'
              },
              login.label
            ),
            _react2.default.createElement(
              'ul',
              { className: styles.sidebarLinks },
              this.getSidebarLinks(sidebarLinks).map(this.renderSidebarLink)
            ),
            _react2.default.createElement(
              _Spacer2.default,
              { spacing: { mobile: 'medium', tablet: 'large' } },
              renderPromotions.map(function (_ref4) {
                var key = _ref4.key,
                    promotion = _ref4.promotion;
                return _react2.default.createElement(
                  _Spacer2.default,
                  { key: key, adjacentVerticalSpacing: { mobile: 'medium', tablet: 'large' } },
                  promotion()
                );
              }),
              this.renderPicker('languages', languages, onLanguageChange),
              this.renderPicker('countries', countries, onCountryChange)
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: styles.bar },
        this.renderHeader(),
        this.renderSidebar()
      );
    }
  }]);

  return NavHeader;
}(_react2.default.Component);

NavHeader.displayName = 'NavHeader';
exports.default = NavHeader;


NavHeader.propTypes = {
  /**
   * Additional links to be displayed in the nav, in priority order. Protected links
   * are displayed in the sidebar nav, require that the user is logged in to be seen.
   * Non-protected links displayed in the visible header nav unless there isn't room,
   * in which case they move inside the sidebar nav under any protected links.
   * Either onClick or href are accepted.
   */
  links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string.isRequired,
    href: _propTypes2.default.string,
    subtext: _propTypes2.default.string,
    isProtected: _propTypes2.default.bool
  })),

  /**
   * Flag to indicate whether the user is logged in.
   */
  isLoggedIn: _propTypes2.default.bool,

  /**
   * The logout link information. Either onClick or href are accepted.
   */
  logout: _propTypes2.default.shape({
    label: _propTypes2.default.string.isRequired,
    href: _propTypes2.default.string,
    onClick: _propTypes2.default.func
  }).isRequired,

  /**
   * The login link information. Either onClick or href are accepted.
   */
  login: _propTypes2.default.shape({
    label: _propTypes2.default.string.isRequired,
    href: _propTypes2.default.string,
    onClick: _propTypes2.default.func
  }).isRequired,

  /**
   * The home link information for the Deliveroo logo, i.e. to take you to the homepage.
   */
  home: _propTypes2.default.shape({
    onClick: _propTypes2.default.func,
    href: _propTypes2.default.string
  }),

  /**
   * The label for the menu button that always shows on the screen.
   */
  menuLabel: _propTypes2.default.string.isRequired,

  /**
   * List of languages which will be displayed in the langauge selector.
   */
  languages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string.isRequired,
    href: _propTypes2.default.string
  })),

  /**
   * A change handler that gets called with the language href whenever
   * the language is changed.
   */
  onLanguageChange: _propTypes2.default.func,

  /**
   * List of countries which will be displayed in the country selector.
   */
  countries: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string.isRequired,
    href: _propTypes2.default.string
  })),

  /**
   * A change handler that gets called with the country href whenever
   * the country is changed.
   */
  onCountryChange: _propTypes2.default.func,

  /**
   * Logo variant, so the Chinese logo can be used where appropriate.
   */
  logoVariant: _propTypes2.default.oneOf(['chinese', 'deloveroo']),

  /**
   * Logo color, so it can be used on different colour backgrounds.
   */
  logoColor: _propTypes2.default.oneOf(['teal', 'white']),

  /**
   * If it should overlay content underneath it. The alternative is a solid white bar.
   */
  isSolidBar: _propTypes2.default.bool,

  /**
   * Allows you to specify the portion of your app that should be hidden (via
   * aria-hidden) to prevent assistive technologies such as screenreaders from
   * reading content outside of the menu when it’s open.
   */
  appElement: _propTypes2.default.string.isRequired,

  /**
   * Allows you to use the header on pages with a larger than standard
   * `maxWidth` passed into `PageContainer`.
   */
  containerMaxWidth: _propTypes2.default.string,

  /**
   * Render prop for promotional content. Any links that have the same label
   * as those in the links prop will only be displayed in the promotional section
   * of the sidebar.
   */
  renderPromotions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    link: _propTypes2.default.shape({ label: _propTypes2.default.string.isRequired }),
    key: _propTypes2.default.string.isRequired,
    promotion: _propTypes2.default.func.isRequired
  })),

  /**
   * Close button label required for accessibility.
   */
  closeButtonLabel: _propTypes2.default.string.isRequired,

  /** Takes a component and renders into NavHeader */
  searchComponent: _propTypes2.default.node
};

NavHeader.defaultProps = {
  links: [],
  isLoggedIn: false,
  languages: [],
  onLanguageChange: undefined,
  countries: [],
  onCountryChange: undefined,
  home: { href: '/' },
  logoVariant: null,
  logoColor: 'teal',
  isSolidBar: true,
  containerMaxWidth: 'default',
  renderPromotions: [],
  searchComponent: null
};